var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4379 16.9983C15.2298 16.9983 15.039 16.9116 14.8827 16.7555L10.7542 12.5229C10.4593 12.2107 10.4593 11.7248 10.7715 11.43C11.0837 11.1351 11.5695 11.1351 11.8644 11.4473L15.9929 15.6973C16.2878 16.0094 16.2878 16.4953 15.9756 16.7901C15.8368 16.9289 15.6286 16.9983 15.4378 16.9983L15.4379 16.9983Z",
    fill: "#778CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06023 13.9816C3.15719 13.9816 6.94279e-05 10.8418 6.94279e-05 6.99078C-0.0171129 3.13978 3.15719 0 7.06023 0C10.9633 0 14.1204 3.13978 14.1204 6.99078C14.1204 10.8418 10.9459 13.9816 7.06023 13.9816ZM7.06023 1.54387C4.00722 1.54387 1.52659 3.98968 1.52659 6.99078C1.52659 9.99175 4.00713 12.4377 7.06023 12.4377C10.0959 12.4377 12.5765 9.99175 12.5765 6.99078C12.5766 3.98968 10.096 1.54387 7.06023 1.54387Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9e3a4d8dec9c743b43a647b499823737.svg";
export { ForwardRef as ReactComponent };